/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';

import { List, makeStyles } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import { loadTranslation } from 'store/translations/thunks/loadTranslation.thunk';
import {
  selectTargetsWithTranslationEnabled,
  selectTranslationsByUserLocale,
} from 'store/translations/selectors/translationSelectors';
import { showOriginalText } from 'store/translations/actions/translations.actions';
import CommentListItem from './commentListItem';

const useStyles = makeStyles((theme) => ({
  root: {},

  commentSectionContainer: {
    display: 'flex',
    flexDirection: 'column-reverse',
    maxHeight: '100%',
    overflowY: 'auto',
    width: '100%',
  },
  commentSectionContainerOverlay: {
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: '100%',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    overscrollBehavior: 'contain',
    pointerEvents: 'auto',
  },
}));

export default function CommentList({ comments, user, overlay }) {
  const classes = useStyles();

  const translationsByUserLocale = useSelector(selectTranslationsByUserLocale);
  const targetsWithTranslationEnabled = useSelector(
    selectTargetsWithTranslationEnabled
  );

  const dispatch = useDispatch();

  const translate = (comment) => {
    // if user changes language, check if there is translation also for that language.
    if (
      !targetsWithTranslationEnabled.includes(comment.id) ||
      (targetsWithTranslationEnabled.includes(comment.id) &&
      translationsByUserLocale
        ? !translationsByUserLocale[comment.id]
        : true)
    ) {
      dispatch(
        loadTranslation({
          targetId: comment.id,
          textToTranslate: comment.content,
          reloadFailedTranslation: true,
        })
      );
    } else {
      dispatch(showOriginalText(comment.id));
    }
  };

  useEffect(() => {
    const commentsToTranslate = comments.filter(
      (comment) =>
        comment.contentType === 'COMMENT' && user.id !== comment.userId
    );
    commentsToTranslate.forEach((comment) => {
      dispatch(
        loadTranslation({
          targetId: comment.id,
          textToTranslate: comment.content,
          reloadFailedTranslation: true,
        })
      );
    });
  }, [comments]);

  return (
    <List
      className={`${classes.commentSectionContainer} ${
        overlay ? classes.commentSectionContainerOverlay : ''
      }`}
    >
      {comments.map((comment, index) => (
        <CommentListItem
          comment={comment}
          key={index}
          user={user}
          translate={translate}
          targetsWithTranslationEnabled={targetsWithTranslationEnabled}
          translationsByUserLocale={translationsByUserLocale}
          overlay={overlay}
        ></CommentListItem>
      ))}
    </List>
  );
}
